export default __webpack_public_path__ + "static/media/just_indetail_illusHeader_tall375.2063930b.png";